<ion-header>
  <ion-toolbar>
    <ion-buttons slot="secondary">
      <ion-button (click)="onCancel()">Cancel</ion-button>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="primary" *ngIf="!hideConfirmButton">
      <ion-button (click)="onConfirm()">Confirm</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar class="no-border">
    <ion-searchbar (ionInput)="onSearchInput($event)" (ionClear)="onSearchClear()"></ion-searchbar>
  </ion-toolbar>
</ion-header>
<ion-content class="lp-padding-horizontal-16">
  <ion-list class="lp-padding-vertical-none">
    <ng-container *ngIf="multiSelect; else singleSelect">
      <ng-container *ngFor="let item of filteredItems">
        <ion-item lines="none" class="lp-padding-start-none">
          <ion-checkbox
            labelPlacement="end"
            justify="start"
            [value]="item"
            [checked]="isChecked(item)"
            (ionChange)="onCheckboxChange($event)">
            <ion-label class="ion-wrap ion-text-wrap">
              <div [ngClass]="{ 'lp-font-weight-700': descriptionKey }">{{ getText(item) }}</div>
              @if (descriptionKey) {
                <div>{{ getDescription(item) }}</div>
              }
            </ion-label>
          </ion-checkbox>
        </ion-item>
        <div class="lp-divider lp-checkbox"></div>
      </ng-container>
    </ng-container>

    <ng-template #singleSelect>
      <ion-radio-group
        [compareWith]="compareWith"
        (ionChange)="onRadioButtonChange($event)"
        [value]="singleSelected">
        <ng-container *ngFor="let item of filteredItems">
          <ion-item lines="none" class="lp-padding-start-none">
            <ion-radio label-placement="end" justify="start" [value]="item">
              <ion-label class="ion-wrap ion-text-wrap">
                <div [ngClass]="{ 'lp-font-weight-700': descriptionKey }">
                  {{ getText(item) }}
                </div>
                @if (descriptionKey) {
                  <div>{{ getDescription(item) }}</div>
                }
              </ion-label>
            </ion-radio>
          </ion-item>
          <div class="lp-divider lp-radio"></div>
        </ng-container>
      </ion-radio-group>
    </ng-template>
  </ion-list>
</ion-content>
